import { render, staticRenderFns } from "./UserAliasItem.vue?vue&type=template&id=3a104460&scoped=true"
import script from "./UserAliasItem.vue?vue&type=script&lang=ts"
export * from "./UserAliasItem.vue?vue&type=script&lang=ts"
import style0 from "./UserAliasItem.vue?vue&type=style&index=0&id=3a104460&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a104460",
  null
  
)

export default component.exports